import { render, staticRenderFns } from "./ContractView.vue?vue&type=template&id=38e1eb22&scoped=true"
import script from "./ContractView.vue?vue&type=script&lang=js"
export * from "./ContractView.vue?vue&type=script&lang=js"
import style0 from "./ContractView.vue?vue&type=style&index=0&id=38e1eb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e1eb22",
  null
  
)

export default component.exports